export const ShowUserAvatar = false
export const CloseBtn = true
export const NavSideStartState = 'open'

export function getNavSideSchema() {
    return []
}